
export const useWorkListCreateTime = defineStore('workListCreateTime', {
    state: () => ({
        createTime: ''
    }),
    actions: {
        updateCreateTime(date: string) {
            this.createTime = date;
        }
    },
    getters: {
        getDate(): string {
            if(this.createTime != ''){
                return  formateDate(this.createTime)
            }
            return this.createTime
        }
    }
})